import * as React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { ConferenceInterface, MeetingStatusTxtMap, JoinMeetingInterrupt } from "@/types";
import { AnyType } from "@/types";
import { useAuth } from "@/component/Auth";
import { checkStoredPlayTips } from "../pub";
import { Dropdown, Menu, message } from "antd";
import copy from "copy-to-clipboard";
import { conference } from "@/api";
import {
  METTINGPAGE_SAVED_MEETING_INFO,
  NORMALSETTINGKEY,
} from "@/config/const";
import { notChromeMessage, storage } from "@/util";
import { Input, Modal } from "antd";

const Container = styled.div`
  width: 100%;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
  transition: background-color 0.3s;
  padding: 5px 10px;
  &:hover {
    background-color: #eee;
  }
  .cname {
    color: #333;
    height: 25px;
    font-size: 14px;
    align-items: center;
    display: flex;
  }
  .cid {
    display: flex;
    color: #999;
    height: 25px;
    align-items: center;
    .ccid,
    .cstatus {
      flex: 1;
    }
  }
  .begin {
    display: flex;
    color: #999;
    height: 25px;
    align-items: center;
    justify-content: space-between;
    a {
      color: red;
    }
    .ml15 {
      margin-left: 15px;
    }
    .operation span {
      color: red;
      cursor: pointer;
    }
  }
`;

interface MeetItemProps {
  item: ConferenceInterface;
  onOperation?: (roomId: string, operation: string) => void;
}

const MeetItem: React.FunctionComponent<MeetItemProps> = ({
  item,
  onOperation = () => {},
}) => {
  const history = useHistory();
  const auth = useAuth();
  const { loginfo } = auth;
  const username = loginfo.realName || loginfo.username;

  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = React.useState(false);
  const [passwordValue, setPasswordValue] = React.useState('');

  const {
    title,
    status = "",
    beginTime = "",
    conferenceNo = "",
    roomId = "",
    type
  } = item;

  const getConferenceInfo = async (cid: string, password?: string) => {
    
     
    try{
      const ret = await conference.conferenceJoin(
        {
          conferenceNo: cid,
          userName: username,
          password
        },
        {
          "X-Conference-No": cid, //	${conferenceNo}	会议号
          "X-Device": "1", //	8
        }
      );
      const con = ret.conference as ConferenceInterface;
      con["X-Channel-Token"] = ret["X-Channel-Token"];
      con["X-Conference-Token"] = ret["X-Conference-Token"];
      con.roleCode = ret.roleCode;
      con.roomid = ret.roomid;
      con.roleName = ret.roleName;
      con.userId = ret.userid;
      con.attendList = ret.attendList;
      return con;
    }catch(e){
      return e;
    }
  };

  const goMetting = async () => {
     
     //检查是否需要播放提示音
    checkStoredPlayTips(item.conferenceNo);
    const browserErrMsg = notChromeMessage();
    if (browserErrMsg) {
      message.error(browserErrMsg);
      return;
    }
    const conf:any = await getConferenceInfo(item.conferenceNo);
    //异常情况处理
    if(conf.code!==undefined){
      let code = conf.code;
      let data = conf.data;
      if(code === JoinMeetingInterrupt.passwordNeeded){
        //请输入会议密码,弹出会议密码输入框,并验证会议密码是否正确
        console.log(`[JoinMeeting] password needed`);
        showPasswordInputDialog(true);
        return;
      }else if(code === JoinMeetingInterrupt.wrongPassword){
        //输入的会议密码不正确
      }
    }else{
      storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
      const setting = storage.get(NORMALSETTINGKEY);
      const url = `/meeting/${roomId}?username=${
        loginfo.realName
      }&audio=${!!setting.mic}&video=${!!setting.video}&speaker=${!!setting.audio}`;
      history.push(url);
    } 
  };


  const showPasswordInputDialog = (bShow:boolean)=>{
    setIsPasswordDialogOpen(bShow);
  }

  const handleShowPasswordInputDialogOk = async () => {
    //获取到password,直接再调用加会接口加入会议
    const conf:any = await getConferenceInfo(item.conferenceNo, passwordValue);
    //异常情况处理
    if(conf.code!==undefined){
      let code = conf.code;
      let data = conf.data;
      if(code === JoinMeetingInterrupt.passwordNeeded){
        //请输入会议密码,弹出会议密码输入框,并验证会议密码是否正确
        console.log(`[JoinMeeting] password needed`);
        showPasswordInputDialog(true);
        return;
      }else if(code === JoinMeetingInterrupt.wrongPassword){
        //输入的会议密码不正确
      }
    }else{
      storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
      const setting = storage.get(NORMALSETTINGKEY);
      const url = `/meeting/${roomId}?username=${
        loginfo.realName
      }&audio=${!!setting.mic}&video=${!!setting.video}&speaker=${!!setting.audio}`;
      history.push(url);
    } 
      
    setIsPasswordDialogOpen(false);
  };

  const handleShowPasswordInputDialogCancel = () => {
    setIsPasswordDialogOpen(false);
  };

  const passwordValueChange = (e: any) => setPasswordValue(e.target.value);

  const menuClick = async (evt: { key: any }) => {
    const { key } = evt;
    if (key === "copy") {
      const meetInfo="Уулзалтын нэр: "+item.title+"\n"+
                     "Уулзалтын ID: "+item.conferenceNo+"\n"+
                     "Уулзалтын цаг: "+item.beginTime+"-"+item.endTime+"\n"+
                     "Хаяг: https://"+ window.location.hostname+"/"+"\n"+
                     "Web хувилбар нь гар утас дэмжихгүй";
      const ret = await copy(meetInfo);
      if (ret) {
        message.success("Уулзалтын мэдээллийг амжилттай хууллаа");
      } else {
        message.error("Хуулахад алдаа гарлаа");
      }
    } else {
      onOperation(item.roomId, key);
    }
  };

  const menu = (
    <Menu onClick={menuClick} style={{ width: 80 }}>
      <Menu.Item key="modify">Өөрчлөх</Menu.Item>
      <Menu.Item key="delete">Устгах</Menu.Item>
      <Menu.Item key="view">Харах</Menu.Item>
      <Menu.Item key="copy">Хуулах</Menu.Item>
    </Menu>
  );

  return (
    <Container>
      <div className="cname">
        <span>{title}</span>
      </div>
      <div className="cid">
        <div className="ccid">Уулзалтын ID: {conferenceNo}</div>
        <div className="cstatus">

          {type===1 ? MeetingStatusTxtMap[status]:"Уншиж байна"}
          </div>
        <div  >{type}</div>
      </div>
      <div className="begin">
        <div className="bbegin">{beginTime}</div>
        <div className="operation">
          <span onClick={goMetting}>Уулзалтад орох</span>
          <Dropdown overlay={menu} placement="bottomRight">
            <span className="ml15">Бусад</span>
          </Dropdown>
        </div>
      </div>

      <Modal 
      title="Нууц үгээ оруулна уу" 
      width={300} 
      centered 
      visible={isPasswordDialogOpen} 
      onOk={handleShowPasswordInputDialogOk} 
      onCancel={handleShowPasswordInputDialogCancel}
      okText="Оруулах"
      cancelText="Болих">
      <Input value={passwordValue} onChange={passwordValueChange} placeholder="Уулзалтын нууц үг" />
      </Modal>

    </Container>
  );
};

export default MeetItem;
/**
 
agenda: ""
agendaId: "477846163400167424"
agendaPermission: 0
allMuteState: 0
allowEarlyEntry: 1
allowSelfUnmute: 1
beginTime: "2021-12-16 14:00:00"
conferenceNo: "1315005711"
createTime: "2021-12-16 13:35:36"
endTime: "2021-12-16 15:00:00"
enterTime: ""
exitTime: ""
id: 1
imTokenId: "1y82gbu1000cgghd8flj4rc610sr3fn7"
links: "http://www.suhangcloud.com/1315005711"
lockedState: 0
muteJoinMeeting: 1
ownerId: "qzxugatsjokkbnf"
ownerName: "闫华"
ownerPassword: ""
password: ""
passwordEnable: 0
playTips: 0
recordPermission: 0
roomId: "191836409873597798"
sharePermission: 0
status: 0
title: "闫华预约的会议"
tokenId: "1y82gbu1000cgghd8flj42m600qz3rdt"
type: 1
updateTime: "2021-12-16 13:35:36"
useSelfConference: 0


 */
